/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//English (United Kingdom)
export default {
  'company-hub.spotlight-extension.config-panel.preamble':
    'Highlight important messages with a visual spotlight. {supportLink}',
  'company-hub.spotlight-extension.config-panel.preamble-link.label': 'Learn more about spotlights',
  'company-hub.spotlight-extension.config-panel.preamble-without-support-link':
    'Highlight important messages with a visual spotlight.',
  'company-hub.spotlight-extension.config-panel.title': 'Spotlight',
  'company-hub.spotlight-extension.hub-element.description': 'Highlight important messages',
  'company-hub.spotlight-extension.hub-element.title': 'Spotlight',
  'company-hub.spotlight-extension.manifest.initial-state.alt-image-text': 'Landscape photography of desert',
  'company-hub.spotlight-extension.manifest.initial-state.text-description':
    'Design a spotlight to highlight your most vital information. Bring the most important messages to life with custom colours, a powerful image, and flexible layouts.',
  'company-hub.spotlight-extension.manifest.initial-state.text-title': 'Give your spotlight a title',
  'company-hub.spotlight-extension.manifest.macro-description': 'Highlight important messages with a visual spotlight.',
  'company-hub.spotlight-extension.manifest.macro-title': 'Spotlight',
  'company-hub.spotlight-extension.manifest.macro-title.new': 'Spotlight [New]',
  'company-hub.spotlight-extension.spotlight-config-panel.content-tab.label': 'Content',
  'company-hub.spotlight-extension.spotlight-config-panel.general-title': 'General',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts-title': 'Layouts',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.frame-above-image.description':
    'Text box overlay on a large image',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.frame-above-image.label':
    'Content frame inside image',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.image-background.description':
    'Full-size image behind your content',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.image-background.label': 'Image background',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.solid-color-background.description':
    'Content in front of a full-width colour',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.solid-color-background.label':
    'Solid colour background',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-content-first.description':
    'Large image on the right with lots of room for content',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-content-first.label':
    'Split design (content first)',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-image-first.description':
    'Large image on the left with lots of room for content',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-image-first.label':
    'Split design (image first)',
  'company-hub.spotlight-extension.spotlight-config-panel.styles-tab.label': 'Styles',
  'company-hub.spotlight-extension.spotlight-config-panel.text-description-label': 'Description',
  'company-hub.spotlight-extension.spotlight-config-panel.text-description-placeholder':
    'Spotlights highlight important messages for your team. Design your spotlight with an image, your custom colours, a short description, and a link.',
  'company-hub.spotlight-extension.spotlight-config-panel.text-image-label': 'Image',
  'company-hub.spotlight-extension.spotlight-config-panel.text-title-label': 'Title',
  'company-hub.spotlight-extension.spotlight-config-panel.text-title-placeholder': 'Give your spotlight a title',
  'company-hub.spotlight-extension.spotlight.background.color': 'Background colour',
  'company-hub.spotlight-extension.spotlight.color-contrast.fail':
    'Your text and background colours don’t work well for readability.',
  'company-hub.spotlight-extension.spotlight.color-contrast.success':
    'Your text and background colours work well for readability.',
  'company-hub.spotlight-extension.spotlight.text.color': 'Text colour',
};
